import script from "./VehicleDashboard.vue?vue&type=script&setup=true&lang=js"
export * from "./VehicleDashboard.vue?vue&type=script&setup=true&lang=js"

import "./VehicleDashboard.vue?vue&type=style&index=0&id=7d8627b6&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7d8627b6"]])

export default __exports__